// extracted by mini-css-extract-plugin
export default {"tooltip":"wU-z","arrow":"xU-z"};